//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { axiosGet } from '../../axios/axios.js'
import { convertRequestFromServer } from '../../forms/Request/Request.js'

export default {
  name: 'BrigadeMapTasksList',
  props: {
    label: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: 'mdi-radiobox-blank'
    },
    config: {
      type: Object,
      default: null
    }
  },
  watch: {
    config: {
      handler: function (config) {
        if (config) {
          this.loadNextPage(config)
        }
      },
      immediate: true
    }
  },
  methods: {
    loadNextPage: async function (config) {
      if (!config || !config.itemsSrc || !config.itemsSrc.length) {
        return
      }

      const pageSize = config.pageSize
      const startIndex = config.itemsToShow.length
      const endIndex = Math.min(startIndex + pageSize, config.itemsSrc.length)

      const ids = []
      const tasks = new Map()
      for (let i = startIndex; i < endIndex; i++) {
        const item = config.itemsSrc[i]
        ids.push(item.id)
        tasks.set(item.id, item)
      }

      config.pageLoading = true
      try {
        const requests = await this.loadRequests(ids)
        requests.forEach(r => {
          r.task = tasks.get(r.requestId) // TODO
          config.itemsToShow.push(r)
        })

        config.itemsLeft = config.itemsSrc.length - config.itemsToShow.length
        config.nextPageSize = Math.min(pageSize, config.itemsLeft)
      } catch (ignored) {
      } finally {
        this.$nextTick(() => {
          config.pageLoading = false
        })
      }
    },
    loadRequests: function (ids) {
      return axiosGet({
        url: '/service/delta/request/getRequests?id=' + ids.join(','),
        onSuccess: (response) => {
          const user = this.$store.getters.getUser
          return response.data.result.map(requestRaw => convertRequestFromServer(requestRaw, user))
        },
        onFailure: 'Ошибка получения информации по заявкам',
        msgTarget: this,
        throws: true
      })
    }
  }
}
